export function toUrlQueryString(record: Record<string, any> = {}): string {
  if (!record) return '';
  let result = '';
  for (const key in record) {
    if (record.hasOwnProperty(key)) {
      const value = record[key];
      if (result) {
        result += '&';
      }
      result += `${key}=${String(value)}`;
    }
  }
  return result;
}

export function addQueryToUrl(
  url: string,
  key: string,
  val: string | number
): string {
  let newParam = key + '=' + val,
    params = '?' + newParam;
  // If the "search" string exists, then build params from it
  if (url) {
    url.includes('?') ? 0 : (params += '?');
    // Try to replace an existance instance
    params = url.replace(new RegExp('([?&])' + key + '[^&]*'), '$1' + newParam);
    // If nothing was replaced, then add the new param to the end
    if (params === url) {
      params += '&' + newParam;
    }
  }
  return params;
}

export function normalizeUrl(url: string) {
  return url.replace(/(?<!:)\/\//g, '/');
}
